// This file was auto-generated by Fern from our API Definition.
const HttpMethodValues = {
    Get: "GET",
    Post: "POST",
    Put: "PUT",
    Patch: "PATCH",
    Delete: "DELETE",
    Head: "HEAD",
};
export const HttpMethod = Object.assign(Object.assign({}, HttpMethodValues), { _visit: (value, visitor) => {
        switch (value) {
            case HttpMethod.Get:
                return visitor.get();
            case HttpMethod.Post:
                return visitor.post();
            case HttpMethod.Put:
                return visitor.put();
            case HttpMethod.Patch:
                return visitor.patch();
            case HttpMethod.Delete:
                return visitor.delete();
            case HttpMethod.Head:
                return visitor.head();
            default:
                return visitor._other();
        }
    } });
